export const ARBITRUM_TOKEN_WHITELIST = []
export const ARBITRUM_TOKEN_BLACKLIST = []